import { FC } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cn } from '@/lib/utils';

type ValidateResult = { valid: boolean };
type ValidateFn = (value: string) => Promise<ValidateResult> | ValidateResult;

interface PhoneInputProps {
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  onBlur?: (name: string, value: string) => void;
  onError?: (name: string, message: string) => void;
  validatePhoneNumber?: ValidateFn;
  placeholder?: string;
  className?: string;
  defaultCountry?: string;
  disabled?: boolean;
}

const PhoneInput: FC<PhoneInputProps> = ({
  name,
  value,
  onChange,
  onBlur,
  onError,
  validatePhoneNumber,
  placeholder = 'Enter phone number',
  className,
  defaultCountry = 'us',
  disabled = false,
  ...rest
}) => {
  return (
    <ReactPhoneInput
      {...rest}
      country={defaultCountry}
      enableSearch
      disableSearchIcon
      value={value?.replace(/^\+/, '')}
      placeholder={placeholder}
      buttonClass="!bg-background"
      searchClass="!bg-background"
      dropdownClass="!bg-background"
      containerClass="w-full !border-white"
      inputClass={cn(
        'flex !h-10 !w-full rounded-md border border-input !bg-background !pr-3',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      onChange={(digits) => {
        const normalized = digits ? `+${digits}` : '';
        onChange(name, normalized);
      }}
      onBlur={async (e) => {
        const val = e?.target?.value
          ? `+${e.target.value.replace(/^\+/, '')}`
          : '';
        if (onBlur) onBlur(name, val);

        if (!val || !validatePhoneNumber) return;

        try {
          const res = await validatePhoneNumber(val);
          if (!res?.valid && onError) {
            onError(name, 'Please enter a valid phone number');
          }
        } catch {
          if (onError) onError(name, 'Please enter a valid phone number');
        }
      }}
      disabled={disabled}
    />
  );
};

export default PhoneInput;
